import React from "react";

const ImageSpecificationsWarning = () => {
  return "Images can be up to 2MB in size and should be in portrait rather than landscape orientation.";
};

export default ImageSpecificationsWarning;
